/**
 * 영문 레이아웃 문자열 데이터를 한글로 바꾸어줍니다.
 * @param {String} layout 
 */
export const translateLayout = (layout) => {
  switch(layout) {
    case 'default':
      return '기본'
    case 'slide':
      return '슬라이드'
    default:
      console.error('layout data ', layout, ' is cannot translate to KR')
      console.info('Return \'기본\'')
      return '기본'
  }
}

/**
 * 컴포넌트의 타입 문자열을 파싱하여 정형화된 데이터로 반환합니다.
 * @param {String} type_str 
 */
export const getType = (type_str) => {
  const slicedAttr = type_str.split('/')
  if (slicedAttr) {
    if (slicedAttr[0]) {
      // if (slicedAttr[0] === "NORMAL") {
      //   return {
      //     prefix : slicedAttr[0],
      //     type : slicedAttr[1]
      //   }
      // }
      return { 
        prefix : slicedAttr[0],
        type : slicedAttr[1]
      }
    }
  }
}